enum MarkerEffect {
  NONE = "none",
  OUTLINE = "outline",
  SHADOW = "shadow",
}

export default MarkerEffect;
